<template>
	<div>
		<div class="container">
			<div
			  title="修改密码" width="20%" center>
			  <el-form :model="myForm" ref="myForm" label-width="80px" :rules="rules">
				  <el-form-item label="用户名称" prop="userName">
					  <el-input style="width: 220px;" :readonly="true" v-model="myForm.loginName"></el-input>
				  </el-form-item>
				  <el-form-item label="原密码" prop="oldPwd">
					  <el-input style="width: 220px;" show-password v-model="myForm.oldPass"></el-input>
				  </el-form-item>
				  <el-form-item label="新密码" prop="newPwd">
					  <el-input style="width: 220px;" show-password v-model="myForm.newPass"></el-input>
				  </el-form-item>
				  <el-form-item label="确认密码" prop="newPwdisOk">
					  <el-input style="width: 220px;" show-password v-model="myForm.newPassAgain"></el-input>
				  </el-form-item>
			  </el-form>
			  <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="insUserSubmit()">提 交</el-button>
			  </span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:"EditPassword",
		data: function() {
			return {
				myForm:{
					loginName:'',
					oldPass:'',
					newPass:'',
					newPassAgain:''
				},
				rules:{
					loginName: [{required: true, message: '请输入用户名称', trigger: 'blur' }],
					oldPass: [{required: true, message: '请输入原密码', trigger: 'blur' }],
					newPass: [{required: true, message: '请输入新密码', trigger: 'blur' }],
					newPassAgain: [{required: true, message: '请输入确认密码', trigger: 'blur' }]
				}
			}
		},
		created() {
			this.insUserDialogOpen();
			//获取url中的参数 取得当前修改密码的用户名称
			let key = localStorage.getItem("sso-key");
			if (!key){
				this.$router.push("/login");
				return
			}
			this.HTTP.get("/sso/login/check?key="+key).then(res=>{
				if (res.data.success){
					this.myForm.loginName = res.data.data.loginName;
				}else{
					this.$router.push("/login");
				}
			})
		},
		methods: {
			insUserDialogOpen:function(){
				this.myForm={
					loginName:'',
					oldPass:'',
					newPass:'',
					newPassAgain:''
				};
			},
			insUserSubmit:function(){
				this.$refs['myForm'].validate((valid) => {
					if (valid) {
						if(this.myForm.newPass!=this.myForm.newPassAgain){
							this.$message.error('两次输入的密码不一致,请重新输入');
							return false;
						}
						this.HTTP.post('/system/user/updatePassword',this.myForm).then(res=>{
							if(res.data.code ==1){
								this.$message.success('操作成功');
							}else{
								this.$message.error(res.data.message);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<style scoped>
	.handle-box {
		margin-bottom: 10px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
	
	.info-div {
		display: flex;
		justify-content: space-around;
		margin-top: 5px;
		font-size: 13px;
	}
	.info-span1 {
		width: 230px;
		font-size: 15px;
	}
	
	.info-span2 {
		width: 230px;
		font-size: 15px;
	}
	
	.info-title {
		margin-right: 4px;
		color: #000000;
	}
	.form-input{
		width: 215px;
	}
</style>
